module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio36-abc8ed00b6e343a2520c48e7064f670b.m4a";